/**
 * tcomb-form helpers for WorldWideWomen.
 */


import t from 'tcomb-form'
import { isEmail } from './index'
import { PromoCodes } from './bfwPromoCodes'



export const WebsiteRefinement = t.refinement(t.String, (url) => {
  let res = url.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)
  return (res == null) ? false : true
});

export const PromoCodeRefinement = t.refinement(t.maybe(t.String), (promo_code) => {
  if (promo_code !== null) {
    promo_code = promo_code.toLowerCase();
    return PromoCodes.includes(promo_code);
  }
  return true;
});


export const EmailRefinement = t.refinement(t.String, (email) => {
  return isEmail(email)
})


export const WebsiteTransformer = {
  format: (url) => {
    return url
  },
  parse: (url) => {
    if(url && !url.startsWith('http')) {
      return `http://${url}`
    }
    return url
  }
}



// WEBPACK FOOTER //
// ./src/utils/tcomb-utils.js